import { Injectable } from '@angular/core';
import { AlertsService } from './AlertsService';

@Injectable({ providedIn: 'root' })

export class CookieService {

  constructor (
    private alertsService: AlertsService,
  ) {}

  /**
   * Agree to terms and services and clear cookie notification
   */
  agreeTerms() {
    this.authorize();
    this.alertsService.clear('cookie');
  }
  /**
   * Checks whether DoNotTrack is enabled
   * @returns boolean
   */
  checkDnT() {
    // Do not Track
    let enabled = false;

    try {
      if (
        window['doNotTrack'] ||
        navigator['doNotTrack'] ||
        navigator['msDoNotTrack']
      ) {
        if (
          window['doNotTrack'] === '1' ||
          navigator['doNotTrack'] === 'yes' ||
          navigator['doNotTrack'] === '1' ||
          navigator['msDoNotTrack'] === '1'
        ) {
          enabled = true;
        }
      }
    } catch (err) {
      enabled = false;
    }
    return enabled;
  }

  /**
   * Check whether cookies are allowed or not
   * @returns boolean
   */
  cookiesAllowed() {
    let allowed = true;

    this.set('test', '123');

    if (this.get('test') === '123') {
      this.remove('test');
    }

    return allowed;
  }

  /**
   * Check if cookies are allowed
   * @returns boolean
   */
  isAuthorized() {

    this.cookiesAllowed();

    if (this.cookiesAllowed() && this.checkDnT()) {
      return 'not_allowed';
    }
    return this.get('cookiesAllowed') === '1';
  }

  /**
   * Save allowed preference
   */
  authorize() {
    this.set('cookiesAllowed', '1');
  }

  /**
   * Save declined preference
   */
  decline() {
    this.set('cookiesAllowed', '0');
  }

  /**
   * Set cookie value
   * @param name - cookie name
   * @param value - cookie value
   * @param [days] - cookie expiration in days
   */
  set (name: any, value: any, days = 365) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${(value || '')}${expires}; path=/; SameSite=Strict; Secure`;
    if (location.protocol === 'http:') {
      document.cookie = `${name}=${(value || '')}${expires}; path=/; SameSite=Strict`;
    }
  }

  /**
   * Get cookie
   * @param name - cookie name
   * @returns cookie value
   */
  get (name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (const cookie of ca) {
      let cookieSubString = cookie;
      while (cookieSubString.startsWith(' ')) {
        cookieSubString = cookieSubString.substring(1, cookieSubString.length);
      }
      if (cookieSubString.startsWith(nameEQ)) {
        return cookieSubString.substring(nameEQ.length, cookieSubString.length);
      }
    }
    return null;
  }

  /**
   * Delete cookie
   * @param name
   */
  remove(name) {
    document.cookie = `${name}=; Max-Age=-99999999; path=/; SameSite=Strict; Secure`;
    if (location.protocol === 'http:') {
      document.cookie = `${name}=; Max-Age=-99999999; path=/; SameSite=Strict`;
    }
  }
}
